import { SWISS_ROUNDS_MAX, SWISS_ROUNDS_MIN } from 'constants/play';

/**
 * Decision 9: recommended Swiss rounds by player count. Up to 8 players 3, 9 to 16
 * players 4, 17 to 32 players 5, 33 to 64 players 6. Shared with the backend as
 * recommendedSwissRounds(n). Below 2 players the recommendation is the 3 of the
 * smallest bracket, which is also the creation default.
 */
export const recommendedSwissRounds = (playerCount: number): number => {
  if (playerCount <= 8) return 3;
  if (playerCount <= 16) return 4;
  if (playerCount <= 32) return 5;
  if (playerCount <= 64) return 6;
  return 7;
};

export const clampSwissRounds = (n: number): number => Math.min(SWISS_ROUNDS_MAX, Math.max(SWISS_ROUNDS_MIN, Math.round(n)));
